const str = `{HEADER}AI 약관

{BODY_TITLE}제1조 (목적)
이 약관은 비디오몬스터 서비스 내에서 제공하는 AI 기반 기능 및 결과물에 관하여 적용되며 기존 이용약관 및 저작권 정책에 추가적용 됩니다.
사용자는 비디오몬스터 서비스에서 제공하는 AI 서비스를 이용하기 전에 본 약관 및 이용약관의 제한 정책에 대해 확인하고 준수할 책임이 있습니다.
본 약관은 회사에 의해 수시로 업데이트 될 수 있습니다.

{BODY_TITLE}제2조 (용어의 정의)
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1) AI 기능: 비디오몬스터가 제공하는 텍스트, 이미지, 동영상 기능 등 AI 기반 모든 기능을 의미함.
2) AI 생성물: 비디오몬스터 서비스 내에서 AI 기능을 통해 제공 및 가공된 텍스트, 이미지, 동영상을 의미함.
3) 기술 파트너: 비디오몬스터가 AI 기능을 제공하기 위해 이용 중인 제 3자 서비스 제공 업체를 의미함.

{BODY_TITLE}제3조 (이용의 제한)
이용약관에서 금지하고 있는 사항 외에도 다음과 같이 AI 생성물을 사용하는 것을 금지하고 있습니다.
1) AI생성물을 인간이 생성한 것처럼 기망하거나 오해할 수 있게 표현하여 사용할 수 없습니다.
2) AI생성물을 사용자 자신이 창작한 것처럼 표현하여 사용할 수 없습니다.
3) AI생성물이 외설적이거나 음란하여 미풍양속을 저해하는 경우 사용할 수 없습니다.
4) AI 생성물이 타인의 권한(개인정보, 초상권, 퍼블리시티권 등)을 위반, 침해하거나 타인을 비방, 모욕하는 경우 사용할 수 없습니다
5) AI생성물이 의학적 결과로 오해 될 수 있는 경우 사용할 수 없습니다.
6) AI생성물은 판매할 수 없습니다.

{BODY_TITLE}제4조 (사용자의 권리 및 의무)
1) 사용자는 AI 기능을 이용하기 위해 입력한 내용에 대한 책임이 있으며, AI 결과물에 대한 저작권은 회사나 사용자에게 있지 않아 권리를 주장할 수 없습니다.
2) 본 약관을 준수하지 않고 AI 결과물을 사용하여 발생하는 법적 책임은 사용자에게 있습니다.
3) 사용자는 머신러닝 모델 또는 관련 기술을 개발하기 위해 AI 결과물을 사용할 수 없습니다.
4) 사용자가 AI 결과물을 공유 및 게시하고자 할 때, 해당 결과물이 AI로 생성되었다는 점을 명확하게 표시할 것을 권고합니다.

{BODY_TITLE}제5조 (회사의 권리 및 의무)
1) 회사는 사용자가 생성AI 결과물 사용시 발생하는 분쟁이나 피해에 대하여 책임지지 않습니다.
2) 회사가 제공하는 생성AI 결과물은 인공지능에 의해 생성되었으며, 당사는 생성AI 결과물의 정확성, 신뢰성 및 대표성에 대해 어떤 보증이나 보장도 제공하지 않습니다.
3) 회사는 사용자가 입력한 텍스트 또는 사용자가 생성한 결과물에 대해 저작권을 주장하지 않습니다.
4) 회사는 사용자의 생성AI 결과물을 서비스를 개선하기 위해 활용하거나, 마케팅 및 홍보 목적으로 사용할 수 있습니다.

{BODY_TITLE}제6조 (기술 파트너)
1) 회사는 생성AI 기반 서비스를 제공하기 위해 제 3자 서비스 제공 업체가 제공하는 기술모델을 사용하고 있습니다.
2) 사용자가 AI 기능 이용을 위해 입력한 데이터의 일부가 제3자 서비스 제공업체와 공유될 수 있으며, 제 3자 제공업체는 이러한 데이터를 자사의 서비스 개선에 사용할 수 있습니다.
3) 제 3자 서비스 제공업체에 공유되는 데이터에는 사용자의 개인 정보가 포함될 수 있으며, 사용자는 당사의 개인정보처리방침이 해당 개인 정보 처리에 적용된다는 것에 동의합니다.
4)제 3자 서비스 제공업체의 정책에 따라 사용자가 거주한 국가에 따라 개인정보 보호 수준이 동일하지 않을 수 있습니다.
- 제 3자 서비스 제공 업체 : Open AI, LLC
- 공유 데이터 : 사용자가 입력한 텍스트

- 제 3자 서비스 제공 업체 : Stability AI
- 공유 데이터 : 사용자가 입력한 이미지, 텍스트

{FOOTER_SUB}공고일자 : 2024년 10월 18일
{FOOTER_SUB_2}시행일자 : 2024년 11월 1일
`

export default str